import React from 'react';
import PropTypes from 'prop-types';
import { LuFileDown, LuFileSpreadsheet, LuFileUp, LuPlus, LuTrash2, LuWallet } from 'react-icons/lu';
import PageHero from '../../../components/data/PageHero';
import Button from '../../../components/ui/Button';
import useBudgetText from '../budgetText';

/**
 * Title card of Gelir & Gider Yönetimi with the page actions. Phones: the two
 * "new" buttons share the first row, the rest are icon buttons below.
 */
const BudgetHeader = ({ onAddIncome, onAddExpense, onImportIncome, onImportExpense, onExcel, onDeleteAll }) => {
  const { label } = useBudgetText();
  const iconButton = 'max-sm:tw-w-full max-sm:tw-px-0';
  return (
    <PageHero
      icon={LuWallet}
      gradient="tw-from-emerald-400 tw-to-teal-600 tw-shadow-emerald-500/30"
      title={label('page.title')}
      subtitle={label('page.subtitle')}
      actionsClassName="tw-grid tw-grid-cols-4 tw-items-center tw-gap-2 sm:tw-flex sm:tw-flex-wrap lg:tw-min-w-0 lg:tw-flex-1 lg:tw-justify-end"
    >
      <Button onClick={onImportIncome} aria-label={label('actions.importIncome')} title={label('actions.importIncomeHint')} className={`${iconButton} max-sm:tw-order-3`}>
        <LuFileDown aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-teal-600 dark:tw-text-teal-300" />
        <span className="tw-hidden sm:tw-inline">{label('actions.importIncome')}</span>
      </Button>
      <Button onClick={onImportExpense} aria-label={label('actions.importExpense')} title={label('actions.importExpenseHint')} className={`${iconButton} max-sm:tw-order-4`}>
        <LuFileUp aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-rose-600 dark:tw-text-rose-300" />
        <span className="tw-hidden sm:tw-inline">{label('actions.importExpense')}</span>
      </Button>
      <Button onClick={onExcel} aria-label={label('actions.excel')} title={label('actions.excelHint')} className={`${iconButton} max-sm:tw-order-5`}>
        <LuFileSpreadsheet aria-hidden="true" className="tw-h-4 tw-w-4 tw-text-emerald-600 dark:tw-text-emerald-400" />
        <span className="tw-hidden sm:tw-inline">{label('actions.excel')}</span>
      </Button>
      <Button
        variant="danger"
        onClick={onDeleteAll}
        aria-label={label('actions.deleteAll')}
        title={label('actions.deleteAllHint')}
        // Test tool: an icon button (the tooltip and the confirm dialog say what it does)
        className="tw-border-dashed max-sm:tw-order-6 max-sm:tw-w-full sm:tw-w-10 sm:tw-px-0"
      >
        <LuTrash2 aria-hidden="true" className="tw-h-4 tw-w-4" />
      </Button>
      <Button variant="success" onClick={onAddIncome} className="max-sm:tw-order-1 max-sm:tw-col-span-2">
        <LuPlus aria-hidden="true" className="tw-h-4 tw-w-4" strokeWidth={2.5} />
        {label('actions.addIncome')}
      </Button>
      <Button variant="primary" onClick={onAddExpense} className="max-sm:tw-order-2 max-sm:tw-col-span-2">
        <LuPlus aria-hidden="true" className="tw-h-4 tw-w-4" strokeWidth={2.5} />
        {label('actions.addExpense')}
      </Button>
    </PageHero>
  );
};

BudgetHeader.propTypes = {
  onAddIncome: PropTypes.func.isRequired,
  onAddExpense: PropTypes.func.isRequired,
  onImportIncome: PropTypes.func.isRequired,
  onImportExpense: PropTypes.func.isRequired,
  onExcel: PropTypes.func.isRequired,
  onDeleteAll: PropTypes.func.isRequired,
};

export default BudgetHeader;
